export const LEXICAL_EMAIL_FORMAT = 'lexical-email'

export const hasLexicalEmailFormat = (template: unknown): boolean =>
  typeof template === 'object' && template !== null && (template as { format?: unknown }).format === LEXICAL_EMAIL_FORMAT
